module.exports = __webpack_public_path__ + "img/img26.2d01017b.png";